import { apiClient } from './api';

class MLService {
  async convertTestFile(fileID) {
    const response = await apiClient.post('/api/convert_test_file', { FileID: fileID });
    return response.data;
  }

  async calculateAccuracy(accuracyText, geminiText) {
    const response = await apiClient.post('/api/calculate_accuracy', {
      accuracy_text: accuracyText,
      gemini_text: geminiText
    });
    return response.data;
  }

  async uploadGeminiOutput(geminiText, accuracyText) {
    const response = await apiClient.post('/api/upload', {
      gemini_text: geminiText,
      accuracy_text: accuracyText
    });
    return response.data;
  }

  async trainWithLogging() {
    const response = await apiClient.post('/api/train_with_logging');
    return response.data;
  }

  async downloadLog(logFileName) {
    const response = await apiClient.get(`/api/download_log/${logFileName}`, {
      responseType: 'blob'
    });
    return response.data;
  }

  async runCode(code, codebaseId = null, mode = 'supervised') {
    const userId = localStorage.getItem('userId');
    const actualCodebaseId = codebaseId || parseInt(userId) * 1000 + Math.floor(Math.random() * 1000);
    
    const response = await apiClient.post('/api/run_code', { 
      code,
      user_id: parseInt(userId),
      codebase_id: actualCodebaseId,
      type: mode
    });
    return response.data;
  }
}

const mlService = new MLService();

export default mlService; 